import {
  Button,
  InvoicesPeriodDetailsTable,
  InvoicesPeriodTable,
} from '@flexo/atoms';
import { RIGHT_DRAWER, store } from '@flexo/reducers';
import { useTranslation } from 'react-i18next';
import styles from './right-drawer-content.module.scss';

export interface PaymentsListDrawerContentProps {
  type: 'overview' | 'details';
  drawerConfig: any;
}

export default function PaymentsListDrawerContent({
  drawerConfig,
  type,
}: PaymentsListDrawerContentProps) {
  const dispatch = store.dispatch;
  const { t } = useTranslation();

  return (
    <div className={styles.Drawer__Content_Payments__List}>
      {type === 'overview' && (
        <div className={styles.Drawer__Content_Payments__List__Overview}>
          <InvoicesPeriodTable data={drawerConfig.data} />{' '}
        </div>
      )}
      {type === 'details' && (
        <div className={styles.Drawer__Content_Payments__List__Details}>
          <InvoicesPeriodDetailsTable data={drawerConfig} />{' '}
        </div>
      )}
      {type === 'details' && (
        <div
          className={
            styles.Drawer__Content_Payments__List__BackButton__Container
          }
        >
          <Button
            variant="secondary"
            color="grey"
            style={{
              maxWidth: 80,
            }}
            onClick={() => {
              dispatch(
                RIGHT_DRAWER.SetDrawer({
                  type: 'COMMUNITY_PAYMENTS_LIST',
                  drawerConfig: drawerConfig?.oldData || {},
                } as any)
              );
            }}
            label={t('widgets.tables.utils.back') as any}
          />
        </div>
      )}
    </div>
  );
}
